exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{font-size:62.5%}#content{height:100%;width:100%;right:0;padding:0;margin:0;background-color:white;overflow-y:auto}#headerWrapper{width:100%;position:relative;background-color:#829750;padding:1em 0;height:5em;z-index:1}#header{height:5em;display:flex}#cws-elm-app{overflow:hidden}#cws-elm-app>div{position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden}\n", ""]);

// exports
